"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetricsInjector = void 0;
const react_1 = __importStar(require("react"));
const spectrometer_injector_1 = require("../util/spectrometer_injector");
const katal_metrics_instance_1 = require("../util/katal_metrics_instance");
exports.MetricsInjector = (props) => {
    const anchor = react_1.default.useRef(null);
    react_1.useEffect(() => {
        katal_metrics_instance_1.initAndResolveMetricsPublisher(props);
    }, [props.updatePublisherTrigger]);
    react_1.useEffect(() => {
        if (anchor.current) {
            spectrometer_injector_1.injectSpectrometer(anchor.current, props);
        }
    }, [props.pathname]);
    return (react_1.default.createElement("div", { style: {
            display: 'none',
        }, "data-testid": "metrics-injector", ref: anchor }));
};
